import React, {useEffect} from "react";
import {Outlet, useNavigate} from "react-router-dom";
import Sidebar from "../components/sidebar/Sidebar";
import {useDispatch, useSelector} from "react-redux";
import {fetchDate, setLoading} from "../store/utility-slice";
import Header from "../components/header/Header";
// import Socket from "../socket/Socket";

const RootLayout = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const {
        isValid,
    } = useSelector(state => state.auth);

    const userRole = useSelector((state) => state.auth.selectedRole);

    useEffect(() => {
        isValid === false && navigate("/login");
        isValid === false && dispatch(setLoading(false));
    }, [dispatch, isValid, navigate]);

    useEffect(() => {
        userRole && dispatch(fetchDate());
    }, [dispatch, userRole]);


    return (
        <>
            {userRole &&
                <>
                    <div className="layout layout-full-sidebar d-grid bg-body-tertiary overflow-hidden">
                        <header className="layout-header">
                            <Header/>
                        </header>
                        <aside className="layout-aside">
                            <Sidebar/>
                        </aside>
                        <main className="layout-content p-4 p-md-6 bg-white mx-3 mx-md-0 rounded-start-4">
                            <Outlet/>
                        </main>
                        <footer className="layout-footer">
                        </footer>
                    </div>
                    {/*<Socket/>*/}
                </>
            }
        </>
    )
};

export default RootLayout;
